import React, { PropTypes } from 'react'
import cn from 'classnames'
import styles from './FormField.scss'

export const FormField = ({ label, field, children, className }) => {
    const showErrorMessage = field && field.touched && field.error

    return (
        <div className={cn(styles['form-field'], className)}>
            {label && <label className="label" htmlFor={label}>{label}</label>}
            <div className="field">
                {children}
                {showErrorMessage && (
                    <p className={cn("error", styles.errorMessage)}>
                        {field.error}
                    </p>
                )}
            </div>
        </div>
    )
}
FormField.propTypes = {
    label: PropTypes.string,
    field: PropTypes.object,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
}



// WEBPACK FOOTER //
// ./components/shared/form-field/FormField.jsx